module.exports = __webpack_public_path__ + "img/report-icon.a45a12dc.svg";